import React, { useState, useEffect } from 'react';
import NavBar from '../Components/NavBar';
import CartProduct from '../Components/CartProduct';
import { useNavigate } from 'react-router-dom';
import "./CartPage.css";
import OrderDetails from '../Components/OrderDetails';
const Cart = () => {
    const navigate = useNavigate();
    const handleCheckout = () => {
        navigate('/payment'); // Adjust this route as needed
    };
    const [cartItems, setCartItems] = useState([]);

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCartItems(storedCart);
    }, []);

    

    return (
        <>
            <NavBar />
            <div className='cart-title'>My Cart</div>
            <div className="parent-class">
           
                <div className="parent-class2">
                    
                    <div class="container">
                    {cartItems.length === 0 ? (
                            <div className="brand-name">Empty Cart</div>
                        ) : (
                            <div className="brand-name">Sound Wave</div>
                        )}
                        {cartItems.map((product, index) => (
                            <CartProduct
                                key={index}
                                ProductName={product.product_name} // Use correct prop names
                                Price={product.price}
                                ImageUrl={"http:" + product.image_url} 
                            />
                        ))}
                    </div>

                </div>
                {cartItems.length !== 0 && (
                    <div className="payment-total">
                        <OrderDetails />
                        <button className='checkout-button' onClick={handleCheckout}>Checkout</button>
                    </div>
                )}
            </div>
        </>
    );
};

export default Cart;
